import styled from 'styled-components'
import { primary, textPrimary, greySecondary } from 'styles/Colors'

export const Container = styled.div`
  width: 100%;
`

export const SectionTitle = styled.h2`
  font-family: coresanscr65;
  font-size: 1.25rem;
  font-weight: 600;
  color: ${textPrimary};
  margin: 0 0 2rem 0;
`

export const FormGrid = styled.div`
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 2rem 3rem;
  
  @media (max-width: 768px) {
    grid-template-columns: 1fr;
    gap: 1.5rem;
  }
`

export const FormGroup = styled.div`
  display: flex;
  flex-direction: column;
  gap: 0.5rem;
`

export const Label = styled.span`
  font-family: coresanscr45;
  font-size: 0.875rem;
  color: #6B7280;
  font-weight: 500;
`

export const Value = styled.div`
  font-family: coresanscr45;
  font-size: 1rem;
  color: ${textPrimary};
  padding: 0.5rem 0;
`

export const EditButton = styled.button`
  padding: 0.25rem 1rem;
  border: 1px solid #d1d5db;
  border-radius: 0.375rem;
  background: white;
  font-family: coresanscr45;
  font-size: 0.875rem;
  color: ${textPrimary};
  cursor: pointer;
  transition: all 0.2s ease;

  &:hover {
    background-color: #f9fafb;
    border-color: ${primary};
  }

  &:focus {
    outline: none;
    box-shadow: 0 0 0 2px rgba(46, 77, 230, 0.2);
  }
`

export const EditInput = styled.input`
  padding: 0.75rem 1rem;
  border: 2px solid #e5e7eb;
  border-radius: 0.375rem;
  font-family: coresanscr45;
  font-size: 1rem;
  color: ${textPrimary};
  background: white;
  transition: all 0.2s ease;

  &:focus {
    outline: none;
    border-color: ${primary};
    box-shadow: 0 0 0 3px rgba(46, 77, 230, 0.1);
  }

  &:hover {
    border-color: #d1d5db;
  }
`

export const ActionButton = styled.button`
  background-color: ${primary};
  color: white;
  padding: 0.75rem 2rem;
  border: none;
  border-radius: 0.375rem;
  font-family: coresanscr55;
  font-size: 0.875rem;
  font-weight: 600;
  cursor: pointer;
  transition: all 0.2s ease;

  &:hover {
    background-color: #2440c4;
    transform: translateY(-1px);
    box-shadow: 0 4px 12px rgba(46, 77, 230, 0.3);
  }

  &:focus {
    outline: none;
    box-shadow: 0 0 0 2px rgba(46, 77, 230, 0.2);
  }

  &:active {
    transform: translateY(0);
  }

  &:disabled {
    background-color: #9ca3af;
    cursor: not-allowed;
    transform: none;
    box-shadow: none;
  }
`